<script>
import { nextTick } from 'vue';
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiRefresh, mdiShuffleVariant, mdiShuffleDisabled, mdiVideoVintage } from '@mdi/js';
import { readAllPosts } from '@/services/MindMovieServices';
import LazySinglePost from '@/components/MindMovieLazySinglePost.vue';

export default {
  components: {
    LazySinglePost,
    SvgIcon
  },
  data() {
    return {
      mdiRefresh, mdiShuffleVariant, mdiShuffleDisabled, mdiVideoVintage,

      uId: localStorage.getItem('uId'),
      token: localStorage.getItem('idToken'),

      showThisManyPostsAtATime: 8, // default 15
      rawPosts: [],
      allPosts: [],

      shuffleThePosts: false,
      pageView: '1',
      startPage: '1',
    };
  },
  computed: {
    postsToDisplay() {
      const sliceStart = parseInt(this.showThisManyPostsAtATime) * (parseInt(this.startPage) - 1);
      const sliceEnd = parseInt(this.showThisManyPostsAtATime) * parseInt(this.pageView);

      // return this.rawPosts.slice(-5); // dev
      return this.allPosts.slice(sliceStart, sliceEnd); // v2

    },
  },
  methods: {
    // HELPERS
    async loadImgurScript() {
      const s = document.createElement('script');
      s.src = `https://s.imgur.com/min/embed.js?cb=${Date.now()}`;
      s.async = true;
      await nextTick();
      document.body.appendChild(s);
    },
    async startTheMindMovie() {

      // set cookies (preferences, shuffle)
      this.$cookies.set('mindmovie_shuffle', this.shuffleThePosts, '1h');

      // check for stored posts
      const storedPosts = JSON.parse(localStorage.getItem('mindmovie_posts'));
      const storedExpire = JSON.parse(localStorage.getItem('mindmovie_posts_expire'));

      // set allPosts (either from localStorage or dbase
      if (storedPosts && storedExpire > Date.now()) { // it's not expired
        this.rawPosts = this.allPosts = storedPosts;
      } else { // it is expired
        await this.getLatestPostsFromDbase();
      }

      // shuffle posts or don't
      if (this.shuffleThePosts) {
        this.allPosts = this.getShuffledPosts(this.allPosts);
      }


    },
    getShuffledPosts(array) {
      return [...array].sort(() => Math.random() - 0.5)
    },
    loadMore() {
      this.pageView = parseInt(this.pageView) + 1;
      this.$router.push({ path: this.$route.path, query: { page: this.pageView } });
      // console.log('*** loadmore > pageView ***', this.pageView);
    },

    async topBarShuffle(shuffle) {
      console.log('*** top bar shuffle -- new shuffle status: ***', shuffle);
      this.shuffleThePosts = shuffle;
      await this.$cookies.set('mindmovie_shuffle',shuffle, '1h');
      this.pageView = '1';
      this.$router.push({ path: this.$route.path, query: { page: this.pageView } });
      await this.startTheMindMovie();
    },
    async topBarRefresh() {
      console.log('*** top bar refresh ***');
      // reset
      localStorage.removeItem('mindmovie_posts');
      localStorage.removeItem('mindmovie_posts_expire');

      await nextTick();
      location.href = '/mindmovie';
      // location.reload();





    },

    // DBASE - get this.rawPosts from dbase
    async getLatestPostsFromDbase() {

      // reset
      this.allPosts = [];
      this.rawPosts = [];
      localStorage.removeItem('mindmovie_posts');
      localStorage.removeItem('mindmovie_posts_expire');

      // api call
      const posts = await readAllPosts(this.uId, this.token);

      // format "post" objects
      if (posts) {
        for (let p of Object.keys(posts)) {
          let n = { id: p, ...posts[p] };
          if (n.type === 'custom') {
            n.src = JSON.parse(n.src);
          }
          // if (n.type === 'imgur') {
          //   this.rawPosts.push(n);
          // }
          // if (this.rawPosts.length <=20) {
          //   this.rawPosts.push(n);
          // }
          this.rawPosts.push(n);
        }

        // update cookies localStorage
        this.$cookies.set('mindmovie_shuffle', this.shuffleThePosts, '1h');
        localStorage.setItem('mindmovie_posts', JSON.stringify(this.rawPosts));
        localStorage.setItem('mindmovie_posts_expire', Date.now() + (24 * 60 * 60 * 1000)); // "expires" in 1d
        // localStorage.setItem('mindmovie_posts_expire', Date.now() + (60 * 60 * 1000)); // "expires" in 1h
      }

      location.reload();

    },
  },
  async mounted() {
    await this.loadImgurScript();
  },
  async created() {
    console.clear();

    // url params
    this.pageView = this.$route.query.page || '1';
    this.startPage = this.$route.query.start || '1';
    if (this.$route.query.page && !this.$route.query.start) {
      this.startPage = this.pageView;
    }
    // shuffle or no?
    const shuff = this.$cookies.get('mindmovie_shuffle');
    // this.shuffleThePosts = shuff === 'true'; // default: shuffle is off
    this.shuffleThePosts = shuff !== 'false'; // default: shuffle is on

    await this.startTheMindMovie();

  },


}
</script>

<template>
  <div class="bg-black text-white">

    <h1 class="text-center pt-3">MindMovie</h1>

    <!-- top-bar: shuffle / refresh -->
    <div id="mind-movie-top-bar" class="px-3 d-flex justify-space-between align-center">
      <!-- shuffle -->
      <svg-icon v-if="shuffleThePosts" @click.prevent="topBarShuffle(false)" type="mdi" :path="mdiShuffleVariant" :size="24" class="ms-1" color="lightgreen"></svg-icon>
      <svg-icon v-else @click.prevent="topBarShuffle(true)" type="mdi" :path="mdiShuffleDisabled" :size="24" class="ms-1" color="grey"></svg-icon>
      <!-- refresh -->
      <svg-icon @click.prevent="topBarRefresh" type="mdi" :path="mdiRefresh" :size="24" class="ms-1" color="lightblue"></svg-icon>
    </div>

    <!-- DISPLAY ALL POSTS -->
    <div id="display-all-posts-container" class="px-4">
      <div v-for="post of postsToDisplay" :key="post.id"
       class="pa-3 my-8"
       style="border: 1px solid white;"
      >
<!--        <LazySinglePost v-if="post.type === 'youtube' " :post="post" :threshold="1600" />-->
<!--        <LazySinglePost v-if="post.type === 'imgur' " :post="post" :threshold="1600" />-->
<!--        <LazySinglePost v-if="post.type === 'custom' " :post="post" :threshold="1600" />-->

        <LazySinglePost :post="post" :threshold="1600" />
      </div>






      <!-- load more button -->
      <div v-if="postsToDisplay.length >= pageView * showThisManyPostsAtATime" class="d-flex justify-center">
        <v-btn @click.prevent="loadMore" color="blue-lighten-4" size="small" class="text-lowercase font-italic">load more</v-btn>
      </div>
      
    </div> <!-- end #DisplayAllPosts -->

  </div>
</template>

<style scoped lang="scss">
//#mind-movie-top-bar {
//  position: sticky;
//  top: 0;                    // sticks right under any fixed header if you got one
//  z-index: 10;               // higher than the posts
//  //background-color: rgb(0, 0, 0);   // keep it solid black so content doesn't bleed through
//  background: transparent;
//  //padding: 8px 12px;         // whatever spacing you like
//  margin-bottom: 8px;        // little breathing room
//  border-bottom: 1px solid #333;   // optional subtle divider
//}
#display-all-posts-container {
  padding-bottom: 120px;
  max-width: 380px;
  margin: 0 auto;
}
</style>
